import WhyTossed from './containers/WhyTossed';

export default WhyTossed;
